import { QRCodeSVG } from "qrcode.react";
import { Laptop, Monitor, Phone, Mail, Clock, Printer } from "lucide-react";
import { LogoMark } from "../components/Logo";
import { BUSINESS } from "../lib/business";

const services = ["Screens & hinges", "Batteries & charging", "Keyboards", "Liquid damage", "Upgrades & SSDs", "Virus removal", "Data rescue", "Gaming PC repairs"];
const steps = ["Request online", "We pick up or you post", "Diagnose & quote", "Fixed & returned"];

const Header = () => (
  <div className="flex items-center justify-between">
    <div className="flex items-center gap-3">
      <LogoMark className="h-11 w-11" />
      <div className="leading-none">
        <p className="font-display text-xl font-extrabold tracking-tight">WILKO TECH LTD</p>
        <p className="mt-1 font-mono text-[9px] tracking-[0.3em] text-slate-300">REPAIRS & CUSTOM GAMING PCS</p>
      </div>
    </div>
    <div className="flex gap-2 text-ember"><Laptop className="h-6 w-6" strokeWidth={1.5} /><Monitor className="h-6 w-6" strokeWidth={1.5} /></div>
  </div>
);

const Info = ({ icon: Icon, children }) => (
  <p className="flex items-center gap-2.5 text-[13px] font-medium"><Icon className="h-4 w-4 text-ember" />{children}</p>
);

export default function Flyer() {
  const qr = new URLSearchParams(window.location.search).get("qr");
  const url = `${qr && qr.startsWith("https://") ? qr : window.location.origin}/request`;
  const SITE_HOST = new URL(url).host.replace(/^www\./, "");
  return (
    <div className="flyer-page min-h-screen bg-neutral-800 py-10 print:bg-white print:p-0">
      <div className="mx-auto mb-6 flex w-[148mm] items-center justify-between print:hidden">
        <p className="text-sm text-slate-300">A5 flyer · print or save as PDF</p>
        <button data-testid="flyer-print-btn" onClick={() => window.print()} className="inline-flex items-center gap-2 bg-ember px-4 py-2.5 text-sm font-semibold text-ink hover:bg-amber-400">
          <Printer className="h-4 w-4" /> Print / Save PDF
        </button>
      </div>
      <article data-testid="flyer-sheet" className="flyer-sheet relative mx-auto flex h-[210mm] w-[148mm] flex-col overflow-hidden bg-ink text-bone shadow-2xl print:shadow-none">
        <div className="absolute inset-0 grid-lines opacity-60" />
        <div className="relative px-[9mm] pt-[8mm]"><Header /></div>
        <div className="relative mt-[6mm] h-[54mm] overflow-hidden">
          <img src="/img/board.jpg" alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
        </div>
        <div className="relative -mt-[16mm] px-[9mm]">
          <h1 className="font-display text-[48px] font-black uppercase leading-[0.86] tracking-[-0.02em]">
            Dead machines,<br /><span className="text-outline">brought</span> back<span className="text-ember">.</span>
          </h1>
          <p className="mt-3 max-w-[110mm] text-[12.5px] leading-snug text-slate-200">Laptop or desktop playing up? Request a repair online in two minutes and track every step with your own reference number.</p>
        </div>
        <div className="relative mt-[4mm] grid grid-cols-2 gap-x-4 gap-y-1 px-[9mm]">
          {services.map((s) => (
            <p key={s} className="flex items-center gap-2 text-[12px]"><span className="h-1.5 w-1.5 rotate-45 bg-ember" />{s}</p>
          ))}
        </div>
        <div data-testid="flyer-gaming-strip" className="relative mx-[9mm] mt-[4mm] flex items-center gap-3 overflow-hidden border border-ember/60 bg-ember/10">
          <img src="/img/gaming-tower.jpg" alt="" className="h-[22mm] w-[26mm] shrink-0 object-cover" />
          <div className="py-2 pr-3">
            <p className="font-mono text-[9px] font-bold uppercase tracking-[0.2em] text-amber-400">New · Now available</p>
            <p className="font-display text-[17px] font-black uppercase leading-none">Custom gaming PCs</p>
            <p className="mt-1 text-[10.5px] leading-snug text-slate-200">Pick every part online and get an instant estimate at {SITE_HOST}/gaming-pc</p>
          </div>
        </div>
        <div className="relative mt-[4mm] grid grid-cols-4 gap-px bg-white/10 mx-[9mm]">
          {steps.map((s, i) => (
            <div key={s} className="bg-ink px-2 py-2">
              <p className="font-mono text-[10px] text-ember">0{i + 1}</p>
              <p className="mt-0.5 text-[10.5px] font-semibold leading-tight">{s}</p>
            </div>
          ))}
        </div>
        <div className="relative mt-auto flex items-end justify-between gap-4 bg-ember px-[9mm] py-[6mm] text-ink">
          <div className="space-y-1.5 [&_svg]:text-ink">
            <p className="font-display text-[20px] font-black uppercase leading-none">Repairs & custom PCs</p>
            <Info icon={Phone}>{BUSINESS.phone}</Info>
            <Info icon={Mail}>{BUSINESS.email}</Info>
            <Info icon={Clock}>{BUSINESS.days} · {BUSINESS.hours}</Info>
          </div>
          <div className="shrink-0 text-center">
            <div className="bg-white p-1.5"><QRCodeSVG value={url} size={92} fgColor="#090D16" level="M" /></div>
            <p className="mt-1 font-mono text-[9px] font-bold uppercase tracking-widest">Scan to book</p>
          </div>
        </div>
      </article>
    </div>
  );
}
